<template>
  <a-modal
    :title="title"
    :visible="visible"
    :width="850"
    @cancel="handleCancel"
  >
    <a-form :form="form" class="formDiv">
      <a-row>
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字段名称">
            <a-input
              v-decorator="['name', { rules: [{ required: true, message: '请输入字段名称！' }] }]"
              autocomplete="off"
              placeholder="请输入字段名称"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字段简称">
            <a-input
              v-decorator="['nameDesc', { rules: [{ required: true, message: '请输入字段简称！' }] }]"
              autocomplete="off"
              placeholder="请输入字段简称"
            />
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字段类型">
            <a-select
              v-decorator="['valueType', { rules: [{ required: true, message: '请选择字段类型！' }] }]"
              placeholder="请选择字段类型"
              @change="changeValueType"
            >
              <a-select-option v-for="(item, index) in valueTypeList" :key="index" :value="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="字段长度限制">
            <a-input
              v-decorator="['lengthMax', {validateTrigger: ['blur'], rules: [{ required: false, message: '请输入字段长度限制！' },{
                pattern: /^(([1-9]\d+)|([2-9]))$/,
                message: '值必须为大于1的正整数！'
              }] }]"
              autocomplete="off"
              placeholder="请输入字段长度限制"
              :disabled="form.getFieldValue('valueType') === 3"
            />
          </a-form-item>
        </a-col>
        <a-col :span="24" class="radioDiv">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="单选要求">
            <a-input
              v-decorator="['valueOptions', { rules: [{ required: form.getFieldValue('valueType') === 2, message: '请输入单选要求！' }] }]"
              :disabled="form.getFieldValue('valueType') === 1 || form.getFieldValue('valueType') === 3"
              autocomplete="off"
              placeholder="请输入单选要求（单选时，用顿号分割每个选择项点例子：A、B、C、D）"
              style="width: calc(100% - 29px)"
            />
            <a-tooltip>
              <template slot="title">
                单选时，用顿号分割每个选择项点例子：A、B、C、D
              </template>
              <a-icon style="font-size: 20px;color: #1791FF;margin-left: 9px;" theme="filled" type="info-circle"/>
            </a-tooltip>
          </a-form-item>
        </a-col>
        <a-col :span="24">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
            <a-textarea
              v-decorator="['remark', { rules: [{ required: false, message: '请输入备注！' }] }]"
              :rows="4"
              placeholder="请输入备注"/>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <template slot="footer">
      <a-button key="back" @click="handleCancel">
        取消
      </a-button>
      <a-button key="submit" :loading="loading" type="primary" @click="handleSubmit">
        保存
      </a-button>
    </template>
  </a-modal>
</template>

<script>
import { saveField } from '@/api/fieldManage'

export default {
  name: 'ViewModules',
  data () {
    return {
      labelCol: { style: 'width: 100px' },
      wrapperCol: { style: 'width: calc(100% - 100px)' },
      title: '',
      type: '',
      model: {},
      form: this.$form.createForm(this, { name: 'proprietors' }),
      visible: false,
      loading: false,
      // 字段类型
      valueTypeList: [
        {
          id: 1,
          name: '填空'
        },
        {
          id: 2,
          name: '单选'
        },
        {
          id: 3,
          name: '日期'
        }
      ]
    }
  },
  created () {

  },
  methods: {
    setTitle (title) {
      this.title = title
    },
    setType (type) {
      this.type = type
      if (type === 'add') {
        this.$nextTick(() => {
          this.form.setFieldsValue({
            valueType: 1
          })
        })
      }
    },
    setModel (model) {
      console.log(model)
      this.model = model
      this.$nextTick(() => {
        this.form.setFieldsValue({
          name: this.model.name,
          nameDesc: this.model.nameDesc,
          valueType: this.model.valueType,
          lengthMax: this.model.lengthMax,
          valueOptions: this.model.valueOptions,
          remark: this.model.remark
        })
      })
    },
    open (visible) {
      this.visible = visible
    },
    handleCancel () {
      this.model = {}
      this.form.resetFields()
      this.visible = false
    },
    // 改变字段类型
    changeValueType (value) {
      if (value === 1) {
        this.form.setFieldsValue({
          valueOptions: ''
        })
      }
    },
    // 保存
    handleSubmit () {
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          const params = { ...values }
          if (this.type === 'edit') {
            params.id = this.model.id
          }
          this.loading = true
          saveField(params).then(res => {
            if (res.status === 0) {
              this.$message.success(res.info.message)
              this.$emit('getTableData')
              this.handleCancel()
              this.loading = false
            } else {
              this.$message.error(res.info.message)
              this.loading = false
            }
          })
            .catch(err => {
              this.$message.error(err.info.message)
              this.loading = false
            })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
